import { Theme, createStyles, makeStyles } from '@material-ui/core';
import {
  EVENT_HEADER_HEIGHT,
  EVENT_TAB_HEIGHT,
  RECORD_PAGE_HEADER_HEIGHT,
  RECORD_SEARCH_BAR_HEIGHT,
} from 'utils/Utils';

const useCommonStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerText: {
      '& .MuiTypography-body1': {
        fontSize: 16,
        color: theme.palette.text.primary,
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '100%',
      },
    },
    formHelperText: {
      '& .MuiFormHelperText-root': {
        fontSize: 14,
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '100%',
      },
    },
    container: {
      backgroundColor: theme.palette.background.paper + '!important',
      height: '100%',
      width: '100%',
      overflow: 'auto',
    },
    commandEventContainer: {
      overflow: 'hidden',
    },
    containerroot: {
      height: '100dvh',
    },
    innerContainer: {
      height: 'auto',
      padding: '32px 50px',
      paddingTop: 0,
      backgroundColor: theme.palette.background.paper,
    },
    eventInnerContainer: {
      height: '100%',
    },
    actionsInnerContainer: {
      height: 'auto',
      padding: '34px 50px',
      paddingBottom: 0,
      paddingTop: 0,
    },
    body: {
      marginTop: 2,
      width: '100%',
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 5,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'row',
    },
    commandEventBody: {
      height: `calc(100% - ${RECORD_PAGE_HEADER_HEIGHT}px)`,
    },
    tabContainer: {
      marginTop: 2,
      width: '100%',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    },
    eventTabContainer: {
      height: `calc(100% - ${EVENT_HEADER_HEIGHT}px)`,
    },
    tabs: {
      padding: '0 12px',
      minHeight: 40,
    },
    leftPanel: {
      width: 390,
      borderRight: `1px solid ${theme.palette.divider}`,
      height: '100%',
    },
    dropable: {
      height: `calc(100% - ${RECORD_SEARCH_BAR_HEIGHT}px)`,
      overflow: 'auto',
    },
    panelContainer: {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 4,
      marginTop: 15,
      padding: 0,
      overflow: 'hidden',
      height: '100%',
      backgroundColor: theme.palette.background.paper,
    },
    fullHeight: {
      height: '100%',
    },
    eventPanel: {
      height: `calc(100% - ${EVENT_TAB_HEIGHT}px)`,
      overflow: 'auto',
    },
    headerContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: 18,
    },
    leftPanelRoot: {
      width: 390,
      borderRight: `1px solid ${theme.palette.divider}`,
      overflow: 'hidden',
    },
    rootContainer: {
      flexDirection: 'column',
      alignItems: 'baseline !important',
      justifyContent: 'space-between',
      display: 'block !important',
    },
    dividers: {
      position: 'sticky' as const,
      top: 128,
      zIndex: 999,
    },
    leftContent: {
      display: 'flex',
      alignItems: 'center',
    },
    rightContent: {
      display: 'flex',
    },
    title: {
      fontWeight: 500,
      color: theme.palette.text.primary,
      marginRight: 10,
    },
    cancelBtn: {
      width: 118,
      height: 40,
      color: theme.palette.text.secondary,
      boxShadow: `0px 2px 4px 0px ${theme.palette.divider}`,
      marginRight: 12,
      textTransform: 'none',
      fontSize: 16,
      fontWeight: 500,
    },
    saveBtn: {
      width: 111,
      height: 40,
      fontSize: 16,
      fontWeight: 500,
      boxShadow: `0px 2px 4px 0px ${theme.palette.divider}`,
      textTransform: 'none',
    },
    titleBarContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'sticky',
      padding: '32px 0px 15px 0px',
      top: 0,
      backgroundColor: theme.palette.background.paper,
      zIndex: 999,
    },
    header: {
      color: theme.palette.text.primary,
      fontWeight: 500,
      fontSize: 24,
    },
    saveBtnRoot: {
      borderRadius: 5,
      border: `1px solid ${theme.palette.primary.main}`,
      boxShadow: `0px 2px 4px 0px ${theme.palette.divider}`,
      width: 111,
      height: 40,
    },
    saveBtnText: {
      color: theme.palette.primary.main,
      fontSize: 16,
      fontWeight: 500,
      lineHeight: '100%',
    },
    simulatorBtnRoot: {
      borderRadius: 5,
      border: 'none',
      boxShadow: `0px 2px 4px 0px ${theme.palette.divider}`,
    },
    simulatorBtnText: {
      color: theme.palette.text.secondary,
    },
    titleRow: { display: 'flex', alignItems: 'center' },
    titleMenuContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 10px',
    },
    menuRoot: {},
    menuItem: {
      width: 170,
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    button: {
      width: '100%',
    },
    menu: {
      fontWeight: 400,
      fontSize: 15,
      fontStyle: 'normal',
      color: theme.palette.text.primary,
      textAlign: 'left',
    },
    buttonIcon: {
      marginRight: 10,
      height: 21,
      width: 21,
    },
    buttonContainer: {
      display: 'flex',
      gap: 8,
    },
    text: {
      fontSize: 16,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '100%',
    },
    addButton: {
      width: 110,
      height: 40,
      fontSize: 16,
      fontWeight: 500,
      fontStyle: 'normal',
    },
    buttons: {
      backgroundColor: theme.palette.background.paper,
      borderStyle: 'solid',
      borderWidth: 1,
      borderColor: theme.palette.primary.main,
      borderRadius: 4,
      fontSize: 16,
      fontWeight: 500,
      fontStyle: 'normal',
      height: 40,
    },
    label: { textTransform: 'none' },
    settingsDivider: {
      margin: '50px 0',
    },
    firstSettingsContainer: {
      marginTop: 40,
    },
  })
);

export default useCommonStyles;
